import { createFileRoute } from "@tanstack/react-router";

import SystemSettingsPage from "@/features/dashboard/pages/system-settings";

export const Route = createFileRoute("/(app)/ops/delivery/settings")({
  component: () => <SystemSettingsPage />,
});
